// extracted by mini-css-extract-plugin
export default {"cls1":"ConfirmationModal-cls1_iwS","cls2":"ConfirmationModal-cls2_G_o ConfirmationModal-cls1_iwS"};